import Vue from 'vue'

import * as types from '../types';
import {getIdFromProduct} from '../helper';
import {config, categorieUrl, productUrl, categoryImageUrl, collectionImageUrl, configImage} from '../../api';
import {getTypeFilterAttribute, getTypeFilterFeature} from '../../api/type';

const state = {
    collection: {},
    products: {},
    bestsellers: {},
    category: {},
    categories: []
};

const getters = {
    /**
     *
     * @param state
     * @returns {*}
     */
    [types.GET_COLLECTION]: state => {
        return state;
    },
    /**
     *
     * @param state
     * @returns {*}
     */
    [types.GET_CONTENT1]: (state) => {
        return state.collection.content1;
    },
    /**
     *
     * @param state
     * @returns {*}
     */
    [types.GET_CONTENT2]: (state) => {
        return state.collection.content2;
    },
    /**
     *
     * @param state
     * @returns {*}
     */
    [types.GET_FEATURES]: (state) => {
        const {features} = state.collection;
        return features ? features : [];
    },
    /**
     *
     * @param state
     * @returns {state.collection.attributesGroup|*|collection.attributesGroup}
     */
    [types.GET_ATTRIBUTES_GROUP]: (state) => {
        const {attributesGroup} = state.collection;
        return attributesGroup;
    },
    /**
     *
     * @param state
     * @returns {number}
     */
    [types.GET_ID_CATEGORY]: (state) => {
        const {id_category} = state.category;
        return id_category ? Number.parseInt(id_category, 10) : 0;
    },
    /**
     *
     * @param state
     * @returns {*}
     */
    [types.GET_NB_PRODUCT_DISPLAY]: (state) => {
        const {nbProductsDiplay} = state.category;
        return nbProductsDiplay ? nbProductsDiplay : 0;
    },
    /**
     *
     * @param state
     * @returns {{}}
     */
    [types.GET_CATEGORY]: (state) => {
        const {category} = state;
        return category ? category : {};
    },
    /**
     *
     * @param state
     * @returns {Array}
     */
    [types.GET_CATEGORIES]: (state) => {
        const {categories} = state;
        return categories ? categories : [];
    }
};


const actions = {
    /**
     *
     * @param state
     * @param commit
     * @param dispatch
     * @param collection
     */
    [types.LOAD_DATA_COLLECTION]: ({state, commit, dispatch}, {collection}) => {
        commit(types.MUTATE_INIT_COLLECTION, {collection});
        const {
            id,
            id_category,
            products,
            categories,
            bestsellers
        } = collection;

        if (collection) {
            dispatch(types.INIT_COLLECTION, {id, collection})
        }
        if (id_category) {
            dispatch(types.INIT_CATEGORY, {id_category, collection});
        }

        if (products) {
            dispatch(types.INIT_CATEGORY_PRODUCTS, {products});
        }

        if (categories) {
            dispatch(types.INIT_CATEGORIES, {categories});
        }

        // best sellers
        if (bestsellers) {
            dispatch(types.INIT_BESTSELLER, {bestsellers});
        }

    },

    /**
     * 
     * @param commit
     * @param dispatch
     * @param collection
     */
    [types.INIT_COLLECTION] : ({commit, dispatch}, {id}) => {
          const image = collectionImageUrl(id);
          commit(types.MUTATE_ADD_COLLECTION_IMAGE, {image, id});
    },
    /**
     *
     * @param commit
     * @param dispatch
     * @param id_category
     * @param collection
     */
    [types.INIT_CATEGORY]: ({commit, dispatch}, {id_category, collection}) => {
        dispatch(types.INIT_ATTRIBUTES_FEATURES, {collection});

        Vue.http.get(categorieUrl(id_category), config)
            .then(response => {
                return response.json();
            })
            .then(response => {
                commit(types.MUTATE_INIT_CATEGORY, {...response});
                dispatch(types.INIT_CATEGORY_PRODUCTS, {...response.category.associations});
            });
    },
    /**
     *
     * @param commit
     * @param dispatch
     * @param id_category
     * @param collection
     */
    [types.INIT_CATEGORIES]: ({commit, dispatch}, {categories}) => {

        categories.forEach(function (category) {
            Vue.http.get(categorieUrl(category), config)
                .then(response => {
                    return response.json();
                })
                .then(response => {
                    commit(types.MUTATE_INIT_CATEGORIES, {...response});
                    /*if(category){
                        const {id} = category;
                        Vue.http.get(categoryImageUrl(id), configImage)
                            .then(responseImage => {
                                return responseImage.blob();
                            })
                            .then(blob => {
                                const image = URL.createObjectURL(blob);
                                commit(types.MUTATE_INIT_CATEGORIES, {...response});
                                commit(types.MUTATE_ADD_CATEGORY_IMAGE, {image, id});
                            });
                    }*/
                });
        });
    },
    /**
     *
     * @param commit
     * @param dispatch
     * @param products
     */
    [types.INIT_CATEGORY_PRODUCTS]: ({commit, dispatch}, {products}) => {
        if (products) {
            products.forEach(function (product) {
                dispatch(types.LOAD_PRODUCT, {
                    url: productUrl(getIdFromProduct(product)),
                    config,
                    addResult: true
                });
            });
            commit(types.MUTATE_INIT_PRODUCT_CATEGORY, products);
        }
    },


    [types.INIT_BESTSELLER]: ({commit, dispatch}, {bestsellers}) => {
        if (bestsellers) {
            bestsellers.forEach(function (product) {
                dispatch(types.LOAD_BESTSELLER, {
                    url: productUrl(getIdFromProduct(product)),
                    config,
                    addResult: true
                });
            });
            commit(types.MUTATE_INIT_BESTSELLERS, bestsellers);
        }
    },
    /**
     *
     * @param dispatch
     * @param attributesGroup
     * @param features
     */
    [types.INIT_ATTRIBUTES_FEATURES]: ({dispatch}, {attributesGroup, features}) => {
        if (attributesGroup) {
            dispatch(types.ADD_ATTRIBUTES_FEATURES, {
                elements: attributesGroup,
                type: getTypeFilterAttribute()
            });
        }

        if (features) {
            dispatch(types.ADD_ATTRIBUTES_FEATURES, {
                elements: features,
                type: getTypeFilterFeature()
            });
        }
    },
    /**
     *
     * @param commit
     * @param elements
     * @param type
     */
    [types.ADD_ATTRIBUTES_FEATURES]: ({commit}, {elements, type}) => {

        elements.forEach((element) => {
            commit(types.MUTATE_INIT_FILTER_VALUE, {
                values: element.values,
                type: type,
                id: parseInt(element.id),
                name: element.name
            });
        });
    },
};

const mutations = {
    /**
     *
     * @param state
     * @param collection
     */
    [types.MUTATE_INIT_COLLECTION]: (state, {collection}) => {
        state.collection = collection;
    },
    /**
     *
     * @param state
     * @param category
     */
    [types.MUTATE_INIT_CATEGORY]: (state, {category}) => {
        state.collection.category = category;
        state.category = category;
    },
    /**
     *
     * @param state
     * @param category
     */
    [types.MUTATE_INIT_CATEGORIES]: (state, {category}) => {
        state.categories.push(category);
    },
    /**
     *
     * @param state
     * @param products
     */
    [types.MUTATE_INIT_PRODUCT_CATEGORY]: (state, products) => {
        state.products = products;
    },

    [types.MUTATE_INIT_BESTSELLERS]: (state, bestsellers) => {
        state.bestsellers = bestsellers;
    },
    /**
     *
     * @param state
     * @param products
     */
    [types.MUTATE_ADD_CATEGORY_IMAGE]: (state, {image, id}) => {
        const category = state.categories.find((item) => item.id === id);
        if (category) {
            category.image = image;
        }
    },

    /**
     *
     * @param state
     * @param image
     * @param id
     */
    [types.MUTATE_ADD_COLLECTION_IMAGE]: (state, {image, id}) => {
        state.collection.image = image;
    }
};

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/collection.js